export default __webpack_public_path__ + "static/media/online store.c49ae76a.svg";